import { PayloadAction, createSlice } from "@reduxjs/toolkit"
import { PURGE } from "redux-persist"
import { Message } from "./messagesSlice"

export type ChatRepliesState = Record<string, Message>

export type ComposerSurface = "driver" | "agent"

export const chatReplyKey = (chatJid: string, surface: ComposerSurface) =>
  `${chatJid}::${surface}`

const initialState: ChatRepliesState = {}

export const chatRepliesSlice = createSlice({
  name: "chatReplies",
  initialState,
  reducers: {
    setChatReplyMessage: (
      state,
      action: PayloadAction<{
        chatJid: string
        surface: ComposerSurface
        message: Message
      }>,
    ) => {
      state[chatReplyKey(action.payload.chatJid, action.payload.surface)] =
        action.payload.message
    },
    clearReplyMessage: (
      state,
      action: PayloadAction<{ chatJid: string; surface: ComposerSurface }>,
    ) => {
      delete state[chatReplyKey(action.payload.chatJid, action.payload.surface)]
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState)
  },
})

export const { setChatReplyMessage, clearReplyMessage } =
  chatRepliesSlice.actions

export default chatRepliesSlice.reducer
